import React from 'react';
import { cyberSensei } from '../../content/siteContent';
import { CheckIcon, ExternalLinkIcon, HexagonIcon } from './Icons';
import CyberSenseiLogo from '../../assets/img/logo-cybersensei.png';

export default function CyberSensei() {
  return (
    <section id="cybersensei" className="section-wrap section-wrap--tight-top">
      <div className="cybersensei-wrap">
        <div className="cybersensei-grid">
          <div>
            <div className="cyber-pill">
              <HexagonIcon />
              {cyberSensei.pill}
            </div>
            <h2 className="cyber-title">
              {cyberSensei.titleStart} <span className="text-accent">{cyberSensei.titleHighlight}</span>
            </h2>
            <p className="cyber-text">{cyberSensei.text}</p>
            <ul className="feature-list">
              {cyberSensei.features.map((feature) => (
                <li className="feature-item" key={feature.title}>
                  <CheckIcon />
                  <span>
                    <strong>{feature.title}</strong> {feature.text}
                  </span>
                </li>
              ))}
            </ul>
            <a
              id="SaibaMais"
              href={cyberSensei.link}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold btn-gold--cyber"
            >
              <span>{cyberSensei.button}</span>
              <ExternalLinkIcon />
            </a>
          </div>

          <div>
            <div className="cyber-badge-display">
              <div className="cyber-logo-plate">
                <img src={CyberSenseiLogo} alt="CyberSensei" className="cyber-logo-img" width="240" />
              </div>
              <h3 className="cyber-badge-title">{cyberSensei.badgeTitle}</h3>
              <p className="cyber-badge-text">{cyberSensei.badgeText}</p>
              <div className="cyber-chip">{cyberSensei.badgeChip}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
